import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  // Sidebar state
  sidebarPinned: boolean;
  sidebarOpen: boolean;
  collapsedCategories: Record<string, boolean>;

  // Theme state
  themeMode: 'light' | 'dark';

  // Agent panel state
  agentPanelOpen: boolean;
  agentPanelWidth: number; // percentage (30-70)

  // Actions
  setSidebarPinned: (pinned: boolean) => void;
  setSidebarOpen: (open: boolean) => void;
  toggleCategory: (categoryId: string) => void;
  toggleTheme: () => void;
  setThemeMode: (mode: 'light' | 'dark') => void;
  setAgentPanelOpen: (open: boolean) => void;
  setAgentPanelWidth: (width: number) => void;
  toggleAgentPanel: () => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      // Initial state
      sidebarPinned: false,
      sidebarOpen: false,
      collapsedCategories: {},
      themeMode: 'light',
      agentPanelOpen: true,
      agentPanelWidth: 35,

      // Actions
      setSidebarPinned: (pinned) => set({ sidebarPinned: pinned }),
      setSidebarOpen: (open) => set({ sidebarOpen: open }),
      toggleCategory: (categoryId) =>
        set((state) => ({
          collapsedCategories: {
            ...state.collapsedCategories,
            [categoryId]: !state.collapsedCategories[categoryId],
          },
        })),
      toggleTheme: () =>
        set((state) => ({
          themeMode: state.themeMode === 'light' ? 'dark' : 'light',
        })),
      setThemeMode: (mode) => set({ themeMode: mode }),
      setAgentPanelOpen: (open) => set({ agentPanelOpen: open }),
      setAgentPanelWidth: (width) => set({ agentPanelWidth: Math.min(70, Math.max(30, width)) }),
      toggleAgentPanel: () => set((state) => ({ agentPanelOpen: !state.agentPanelOpen })),
    }),
    {
      name: 'diggens-ui-store',
      partialize: (state) => ({
        sidebarPinned: state.sidebarPinned,
        collapsedCategories: state.collapsedCategories,
        themeMode: state.themeMode,
        agentPanelWidth: state.agentPanelWidth,
      }),
    }
  )
);
